import { render, staticRenderFns } from "./navTab.vue?vue&type=template&id=0ad1d73a&"
import script from "./navTab.vue?vue&type=script&lang=js&"
export * from "./navTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/tabs/navTab.vue"
export default component.exports